import { LayoutGrid, List, Eye, EyeOff } from 'lucide-react'
import type { ReactNode } from 'react'
import {
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
  ToolbarToggleGroup,
  type SegmentTab,
} from '@/components/ui/page-toolbar'

type RocketTab = 'pipeline' | 'history' | 'trash'

interface RocketSearchTopbarProps {
  tabs: SegmentTab<RocketTab>[]
  activeTab: RocketTab
  onTabChange: (tab: RocketTab) => void
  viewMode: 'kanban' | 'list'
  onViewModeChange: (mode: 'kanban' | 'list') => void
  metricsVisible: boolean
  onMetricsVisibleChange: (visible: boolean) => void
  filters?: ReactNode
}

export function RocketSearchTopbar({
  tabs,
  activeTab,
  onTabChange,
  viewMode,
  onViewModeChange,
  metricsVisible,
  onMetricsVisibleChange,
  filters,
}: RocketSearchTopbarProps) {
  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          tabs={tabs}
          value={activeTab}
          onChange={onTabChange}
          ariaLabel='Rocket Search'
        />
      }
      controls={
        activeTab === 'pipeline' ? (
          <ToolbarControlsGroup>
            <ToolbarIconButton
              active={metricsVisible}
              onClick={() => onMetricsVisibleChange(!metricsVisible)}
              title={metricsVisible ? 'Ocultar métricas' : 'Mostrar métricas'}
              aria-label={metricsVisible ? 'Ocultar métricas' : 'Mostrar métricas'}
            >
              {metricsVisible ? <Eye size={16} /> : <EyeOff size={16} />}
            </ToolbarIconButton>
            <ToolbarToggleGroup
              value={viewMode}
              onChange={onViewModeChange}
              options={[
                { id: 'kanban', icon: LayoutGrid, label: 'Visão Kanban' },
                { id: 'list', icon: List, label: 'Visão Lista' },
              ]}
            />
          </ToolbarControlsGroup>
        ) : null
      }
      filters={filters}
    />
  )
}
